/**
 * Map a failed void request onto a message the floor can act on.
 *
 * PinEntryModal used to print "Invalid PIN. Try again." for every non-2xx —
 * 400 status guard, 404 missing row, 409 already-voided, 500 write failure.
 * Mizaj 20260906-009 then spent an evening rotating a working manager PIN
 * against a Postgres type error on qty>1 lines. Same lesson as
 * ReopenDayDialog (F-CTRL-N31): only 403 / invalid_manager_pin is a PIN miss.
 */
export function messageForVoidFailure(err: {
  code?: string
  status?: number
  isNetworkError?: boolean
  message?: string
}): string {
  if (err.isNetworkError) {
    return "Couldn't reach the server. Check the connection and try again."
  }
  if (err.status === 403 || err.code === 'invalid_manager_pin') {
    return 'Invalid PIN. Try again.'
  }
  const msg = err.message?.trim()
  if (msg) return msg
  return 'Void failed. Try again.'
}
